import { VueQueryPlugin } from "@tanstack/vue-query";

export default defineNuxtPlugin((nuxtApp) => {
	const shouldFetch = computed(() => process.client);
	nuxtApp.vueApp.use(VueQueryPlugin, {
		queryClientConfig: {
			defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false, enabled: shouldFetch, refetchOnReconnect: false } },
		},
	});
});
